import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Price from '../../components/Price/Price';

class CustomProductOption extends Component {
  constructor(props) {
    super(props)
  }

  static propTypes = {
    children:   PropTypes.node,
    className:  PropTypes.string,
    isDisabled: PropTypes.bool,
    isFocused:  PropTypes.bool,
    isSelected: PropTypes.bool,
    onFocus:    PropTypes.func,
    onSelect:   PropTypes.func,
    option:     PropTypes.object.isRequired,
  }

  handleMouseDown = (event) => {
    event.preventDefault()
    event.stopPropagation()
    this.props.onSelect(this.props.option, event)
  }

  handleMouseEnter = (event) => {
    this.props.onFocus(this.props.option, event)
  }

  handleMouseMove = (event) => {
    if (this.props.isFocused) return
    this.props.onFocus(this.props.option, event)
  }

  render() {
    let {product} = this.props.option

    return (
      <div className={this.props.className}
           onMouseDown={this.handleMouseDown}
           onMouseEnter={this.handleMouseEnter}
           onMouseMove={this.handleMouseMove}
           title={this.props.option.title}>
        <div className="visible-xs">
          <strong>{product.map_id}</strong> {product.title}
        </div>
        <div className="hidden-xs">
          <table>
            <tr>
              <td sm="1/8"><img className="img-responsive" width="75" src={product.img_src_small} alt=""/> </td>
              <td sm="1/8"><strong>{product.article_nr}</strong></td>
              <td sm="3/8"> {product.desc.short_des} </td>
              <td sm="2/8"> {product.getNotice()}</td>
              <td sm="1/8"> <Price>{product.price}</Price></td>
            </tr>
          </table>
        </div>
        {/*{this.props.children}*/}
      </div>
    )
  }
}

export default CustomProductOption



// WEBPACK FOOTER //
// ./src/components/CustomProductOption/CustomProductOption.js